<section class="feedback grid-y align-middle">
  <!-- MESSAGE -->
  <div class="cell message">
    <div class="text-lg leading-normal font-medium gap-8">
      How likely are you to recommend this tool to another Service member?
    </div>
  </div>

  <!-- SCALE -->
  <div class="cell">
    <section class="grid-x scale-container text-center align-bottom">
      <div class="cell auto text-left pl-2 font-medium">Not at all likely</div>
      <div class="cell auto font-medium">Neutral</div>
      <div class="cell auto text-right pr-2 font-medium">Extremely likely</div>
    </section>
  </div>

  <!-- SLIDER -->
  <div class="cell slider">
    <mat-slider
      [max]="10"
      [min]="0"
      [step]="1"
      color="primary"
      discrete
      showTickMarks
    >
      <input
        aria-label="How likely are you to recommend Career Path DECIDE"
        [(ngModel)]="recommendRating" matSliderThumb />
    </mat-slider>
  </div>

  <!-- COMMENTS -->
  <div class="cell">
    <label for="feedback-comments" class="label">Comments<span class="required">*</span></label>
    <textarea id="feedback-comments"
      class="comment"
      [formControl]="comments"
      maxlength="4000"
      rows="8"
    ></textarea>
  </div>

  <!-- BUTTONS -->
  <div class="actions">
    <cpd-stroked-button
      color="primary"
      text="Cancel"
      size="large"
      mat-dialog-close
    ></cpd-stroked-button>
    <cpd-flat-button
      color="primary"
      [disabled]="comments.invalid"
      text="Submit"
      size="large"
      type="submit"
      (click)="sendUserFeedback()"
    ></cpd-flat-button>
  </div>
</section>
